module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi2-455736c2a907eb1008edcdf926eefbc2.png";